import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "@bamboobox/b2logincheck";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document
  
  .getElementById('root'));
root.render(
  <React.StrictMode>
  <AuthProvider loginURL={window._env_.LOGIN_URL} authcheckURL={window._env_.AUTH_URL}>
    <Router>
    <App />
    </Router>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
